import React from 'react';
import PropTypes from 'prop-types';
import pubsub from 'pubsub-js';
import { ListGroupItem, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import HeaderRun from './header.run';

import angleLogo from '../../../assets/img/logo.png';
import angleLogoSingle from '../../../assets/img/logo-single.png';
//import { redirectLogin } from '../../../helper/auth-helper';

// Necessary to create listGroup inside navigation items
class CustomListGroup extends React.Component {
    render() {
        return <ul className="list-group">{this.props.children}</ul>;
    }
}

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.onClickLogoutButton = this.onClickLogoutButton.bind(this);
        this.onHomeClick = this.onHomeClick.bind(this);
    }

    onHomeClick() {
        let { history, updateSidebar } = this.props;
        updateSidebar('');
        pubsub.publish('refreshSideMenu');
        history.push('/');
    }
    onClickLogoutButton() {
        this.props.logout();
        //redirectLogin();
    }

    componentDidMount() {
        HeaderRun();
    }

    toggleUserblock(e) {
        e.preventDefault();
        pubsub.publish('toggleUserblock');
    }

    render() {
        const ddAlertTitle = (
            <span>
                <em className="icon-bell" />
                <span className="label label-danger">11</span>
            </span>
        );

        let { logo, logoSingle } = this.props;

        const searchFormPanel = (
            <form role="search" action="search.html" className="navbar-form">
                <div className="form-group has-feedback">
                    <input
                        type="text"
                        placeholder="Type and hit enter ..."
                        className="form-control"
                    />
                    <div
                        data-search-dismiss=""
                        className="fa fa-times form-control-feedback"
                    />
                </div>
                <button type="submit" className="hidden btn btn-default">
                    Submit
                </button>
            </form>
        );

        const searchIcon = (
            <li>
                <a href="" data-search-open="">
                    <em className="icon-magnifier" />
                </a>
            </li>
        );

        const fullScreenButton = (
            <li className="visible-lg">
                <a href="" data-toggle-fullscreen="">
                    <em className="fa fa-expand" />
                </a>
            </li>
        );

        const logoutButton = (
            <li className="visible-lg">
                <a onClick={this.onClickLogoutButton}>
                    <em className="fa fa-sign-out" />
                </a>
            </li>
        );
        const homeButton = (
            <li className="visible-lg">
                <a onClick={this.onHomeClick}>
                    <em className="icon-home" />
                </a>
            </li>
        );
        const alertMenu = (
            <NavDropdown
                noCaret
                eventKey={3}
                title={ddAlertTitle}
                className="dropdown-list"
                id="basic-nav-dropdown"
            >
                <CustomListGroup>
                    <ListGroupItem href="">
                        <div className="media-box">
                            <div className="pull-left">
                                <em className="fa fa-twitter text-info" />
                            </div>
                            <div className="media-box-body clearfix">
                                <p className="m0">New followers</p>
                                <p className="m0 text-muted">
                                    <small>1 new follower</small>
                                </p>
                            </div>
                        </div>
                    </ListGroupItem>
                    <ListGroupItem href="">
                        <div className="media-box">
                            <div className="pull-left">
                                <em className="fa fa-envelope text-warning" />
                            </div>
                            <div className="media-box-body clearfix">
                                <p className="m0">New e-mails</p>
                                <p className="m0 text-muted">
                                    <small>You have 10 new emails</small>
                                </p>
                            </div>
                        </div>
                    </ListGroupItem>
                    <ListGroupItem href="">
                        <div className="media-box">
                            <div className="pull-left">
                                <em className="fa fa-tasks text-success" />
                            </div>
                            <div className="media-box-body clearfix">
                                <p className="m0">Pending Tasks</p>
                                <p className="m0 text-muted">
                                    <small>11 pending task</small>
                                </p>
                            </div>
                        </div>
                    </ListGroupItem>
                    <ListGroupItem href="">
                        <small>More notifications</small>
                        <span className="label label-danger pull-right">
                            14
                        </span>
                    </ListGroupItem>
                </CustomListGroup>
            </NavDropdown>
        );

        const offSideBarButton = (
            <li>
                <a
                    href=""
                    data-toggle-state="offsidebar-open"
                    data-no-persist="true"
                >
                    <em className="icon-notebook" />
                </a>
            </li>
        );

        const userAvatarButton = (
            <li>
                {/* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
                <a
                    id="user-block-toggle"
                    href=""
                    title={'Hide/show user details'}
                    onClick={this.toggleUserblock}
                >
                    <em className="icon-user" />
                </a>
            </li>
        );

        const emailInfo = (
            <li>
                <a
                    id="user-block-toggle"
                    href={'mailto:' + this.props.emailInfo}
                    title={'E-mail: ' + this.props.emailInfo}
                >
                    <em className="icon-envelope" />
                </a>
            </li>
        );

        const callInfo = (
            <li>
                <a
                    id="user-block-toggle"
                    href={'tel:' + this.props.callInfo}
                    title={'Call: ' + this.props.callInfo}
                >
                    <em className="icon-phone" />
                </a>
            </li>
        );

        const lockScreenButton = (
            <li>
                <Link to="lock" title="Lock screen">
                    <em className="icon-lock" />
                </Link>
            </li>
        );

        return (
            <header className="topnavbar-wrapper">
                {/* START Top Navbar */}
                <nav className="navbar topnavbar">
                    {/* START navbar header */}
                    <div className="navbar-header">
                        <Link to={'/'} className="navbar-brand">
                            <div className="brand-logo pull-left">
                                <img
                                    src={logo}
                                    alt="App Logo"
                                    className="img-responsive"
                                />
                            </div>
                            <div className="brand-logo-collapsed">
                                <img
                                    src={logoSingle}
                                    alt="App Logo"
                                    className="img-responsive"
                                />
                            </div>
                        </Link>
                    </div>

                    {/* END navbar header */}
                    {/* START Nav wrapper */}
                    <div className="nav-wrapper">
                        {/* START Left navbar */}
                        <ul className="nav navbar-nav">
                            <li>
                                {/*<a
                                    href=""
                                    data-trigger-resize=""
                                    data-toggle-state="aside-collapsed"
                                    className="hidden-xs"
                                >
                                    <em className="fa fa-navicon" />
                                </a>*/}
                                {/* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
                                <a
                                    href=""
                                    data-toggle-state="aside-toggled"
                                    data-no-persist="true"
                                    className="visible-xs sidebar-toggle"
                                >
                                    <em className="fa fa-navicon" />
                                </a>
                            </li>
                            {/* START User avatar toggle */}
                            {this.props.showUserButton && userAvatarButton}
                            {/* END User avatar toggle */}
                            {/* START lock screen */}
                            {this.props.showLockScreen && lockScreenButton}
                            {/* END lock screen */}
                            {/* START contact information section */}
                            {this.props.emailInfo && emailInfo}
                            {/* END contact information section */}
                            {/* START contact information section */}
                            {this.props.callInfo && callInfo}
                            {/* END contact information section */}
                        </ul>
                        {/* END Left navbar */}

                        {/* START Right Navbar */}
                        <ul className="nav navbar-nav navbar-right">
                            {/* Search icon */}
                            {this.props.showSearchButton && searchIcon}
                            {/* Fullscreen (only desktops) */}
                            {this.props.showFullScreenButton &&
                                fullScreenButton}
                            {/* START Alert menu */}
                            {this.props.showAlertMenu && alertMenu}
                            {/* END Alert menu */}
                            {/* START Logout button */}
                            {homeButton}
                            {this.props.showLogOutButton && logoutButton}
                            {/* END Logout Button */}
                            {/* START Offsidebar button */}
                            {this.props.showOffSidebarButton &&
                                offSideBarButton}
                            {/* END Offsidebar menu */}
                        </ul>
                        {/* END Right Navbar */}
                    </div>
                    {/* END Nav wrapper */}
                    {/* START Search form */}
                    {this.props.showSearchButton && searchFormPanel}
                    {/* END Search form */}
                </nav>
                {/* END Top Navbar */}
            </header>
        );
    }
}

Header.propTypes = {
    logo: PropTypes.string,
    logoSingle: PropTypes.string,
    showFullScreenButton: PropTypes.bool,
    showSearchButton: PropTypes.bool,
    showOffSidebarButton: PropTypes.bool,
    showAlertMenu: PropTypes.bool,
    showLockScreen: PropTypes.bool,
    showUserButton: PropTypes.bool,
    showLogOutButton: PropTypes.bool
};

Header.defaultProps = {
    logo: angleLogo,
    logoSingle: angleLogoSingle,
    showSearchButton: false,
    showFullScreenButton: false,
    showAlertMenu: false,
    showOffSidebarButton: false,
    showUserButton: false,
    showLockScreen: false,
    showLogOutButton: false
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/angle/Header/index.js